export const parseApplicationInProgress = (pageData: any[]) => {
  return pageData.reduce((acc: Record<string, any>, question: any) => {
    acc[question.key] = question.answer;
    return acc;
  }, {});
};
